import { FiClock, FiCheckCircle } from "react-icons/fi";
import './supportstats.css';

const SupportStats = () => {
  return (
    <>
      {/* Stats Card */}
      <div className="rf-supportstats-card">
        <h4 className="rf-supportstats-title">Support Stats</h4>

        {/* Avg Response Time */}
        <div className="rf-supportstats-item">
          <div className="rf-supportstats-left">
            <FiClock className="rf-supportstats-icon time" />
            <span>Avg. Response Time</span>
          </div>
          <span className="rf-supportstats-value">1.5 hrs</span>
        </div>
        <div className="rf-supportstats-bar">
          <div className="rf-supportstats-bar-fill" style={{ width: '75%' }}></div>
        </div>

        {/* Resolution Rate */}
        <div className="rf-supportstats-item">
          <div className="rf-supportstats-left">
            <FiCheckCircle className="rf-supportstats-icon check" />
            <span>Resolution Rate</span>
          </div>
          <span className="rf-supportstats-value">94%</span>
        </div>
        <div className="rf-supportstats-bar">
          <div className="rf-supportstats-bar-fill" style={{ width: '94%' }}></div>
        </div>
      </div>

      {/* Support Hours Card */}
      <div className="rf-supportstats-hours">
        <h4 className="rf-supportstats-title">Support Hours</h4>
        <div className="rf-supportstats-item">
          <span>Mon–Fri:</span>
          <span className="rf-supportstats-value">9AM – 6PM EST</span>
        </div>
        <div className="rf-supportstats-item">
          <span>Sat–Sun:</span>
          <span className="rf-supportstats-value">10AM – 4PM EST</span>
        </div>
      </div>
    </>
  );
};

export default SupportStats;
